import React, { useEffect, useState } from 'react';
interface StickyAddToCartProps {
  product: {
    name: string;
    condition: string;
    price: number;
    originalPrice: number;
    discountPercentage: number;
  };
}
export const StickyAddToCart = ({
  product
}: StickyAddToCartProps) => {
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const productImageSection = document.getElementById('product-image-section');
      if (productImageSection) {
        const threshold = productImageSection.offsetTop + productImageSection.offsetHeight;
        setIsSticky(window.scrollY > threshold);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed left-0 right-0 bg-white z-30 border-b border-gray-200 shadow-sm transform transition-transform duration-300 ${isSticky ? 'top-0 translate-y-0' : '-translate-y-full'}`} data-id="element-1275">
      <div className="container mx-auto px-4 py-3" data-id="element-1276">
        <div className="flex flex-col sm:flex-row items-center justify-between" data-id="element-1277">
          <div className="mb-3 sm:mb-0" data-id="element-1278">
            <h3 className="text-lg font-bold text-gray-800" data-id="element-1279">
              {product.name} - {product.condition}
            </h3>
          </div>
          <div className="flex items-center mb-3 sm:mb-0" data-id="element-1280">
            <div className="mr-4 text-right" data-id="element-1281">
              <div className="flex items-baseline" data-id="element-1282">
                <span className="text-xl font-bold text-gray-900" data-id="element-1283">
                  SGD {product.price.toFixed(2)}
                </span>
                <span className="ml-2 text-sm text-red-600 font-medium bg-red-100 px-2 py-0.5 rounded-full" data-id="element-1284">
                  {product.discountPercentage}% OFF
                </span>
              </div>
              <div className="text-sm text-gray-500 line-through" data-id="element-1285">
                SGD {product.originalPrice.toFixed(2)}
              </div>
            </div>
            <button className="bg-black text-white px-6 py-2 rounded-md hover:bg-gray-800 transition-colors" data-id="element-1286">
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>;
};